// Crop registry for the farm. Each crop has a grow time (in game hours),
// seed price, sell price, and the season/phase it prefers.

import { getSeason } from './world.js';

export const CROPS = {
  wheat: {
    id: 'wheat', name: 'wheat', icon: '🌾', color: 0xE8C547,
    growTime: 4, seedPrice: 5, sellPrice: 12,
    seasons: ['spring', 'autumn'],
    desc: 'A trusty golden grain. Loves spring and autumn breezes.'
  },
  carrot: {
    id: 'carrot', name: 'carrot', icon: '🥕', color: 0xF4933C,
    growTime: 6, seedPrice: 8, sellPrice: 20,
    seasons: ['spring', 'autumn'],
    desc: 'Crunchy orange root. Thrives in mild spring and autumn.'
  },
  tomato: {
    id: 'tomato', name: 'tomato', icon: '🍅', color: 0xE23B4E,
    growTime: 8, seedPrice: 12, sellPrice: 32,
    seasons: ['summer'],
    desc: 'Juicy red vine fruit. Needs long sunny summer days.'
  },
  corn: {
    id: 'corn', name: 'corn', icon: '🌽', color: 0xFCEB6B,
    growTime: 10, seedPrice: 18, sellPrice: 48,
    seasons: ['summer'],
    desc: 'Tall golden ears. A summer investment with a big return.'
  }
};

export const CROP_IDS = Object.keys(CROPS);

// How many game hours has a plot been growing? Watering adds effective hours.
// Season bonus/penalty applies (preferred = +30%, off-season = -30%).
export function growthHours(plot, currentHour, currentDay){
  if (!plot) return 0;
  let hours = (currentDay - plot.plantedDay) * 24 + (currentHour - plot.plantedHour);
  hours += (plot.watered || 0);
  const c = CROPS[plot.crop];
  if (c?.seasons){
    const season = getSeason(currentDay);
    hours *= c.seasons.includes(season) ? 1.3 : 0.7;
  }
  return Math.max(0, hours);
}

export function cropStage(plot, currentHour, currentDay){
  if (!plot) return 0;
  const c = CROPS[plot.crop];
  if (!c) return 0;
  const g = growthHours(plot, currentHour, currentDay);
  if (g >= c.growTime) return 3;      // ready
  if (g >= c.growTime * 0.55) return 2; // growing
  if (g >= c.growTime * 0.2) return 1;  // sprout
  return 0;                              // seed
}

export function isReady(plot, currentHour, currentDay){
  return cropStage(plot, currentHour, currentDay) === 3;
}
